module.exports = __webpack_public_path__ + "img/km_05.ae2b01f9.jpeg";